<template>
  <BContainer
    class="px-0"
    fluid
  >
    <BRow
      v-if="busy"
      class="mb-3"
    >
      <BCol
        cols="12"
      >
        <div class="text-center py-5">
          <BIcon
            icon="stopwatch"
            font-scale="5"
            animation="cylon"
          />
          <p class="h3 py-2">
            <strong>Loading . . .</strong>
          </p>
        </div>
      </BCol>
    </BRow>

    <BRow
      v-else-if="areaManagers.rows.length === 0"
    >
      <BCol
        cols="12"
        class="text-center py-5"
      >
        <BIcon
          icon="calendar"
          font-scale="5"
        />
        <p class="h3 py-2">
          <strong>No tasks found</strong>
        </p>
      </BCol>
    </BRow>

    <BCardGroup
      v-else
      columns
    >
      <BCard
        v-for="areaManager in areaManagers.rows"
        :key="areaManager.id"
      >
        <BCardText>
          <div class="d-flex gap-4 mb-3">
            <BAvatar
              v-if="areaManager.photo_url"
              :src="computedProfilePath(areaManager.photo_url)"
              variant="primary"
              size="36px"
            />
            <BAvatar
              v-else
              variant="primary"
              size="36px"
              :text="String(areaManager?.first_name).charAt(0) + String(areaManager?.last_name).charAt(0)"
            />
            <div class="d-flex flex-column justify-content-center">
              <div
                class="font-weight-bold text-primary"
                style="font-size: 0.8rem;"
              >
                {{ areaManager?.first_name }} {{ areaManager?.last_name }}
              </div>
            </div>
          </div>
        </BCardText>
        <BCardText
          v-if="areaManager.tasks_created.length === 0"
          class="text-muted"
        >
          No tasks created
        </BCardText>
        <BCardText
          v-else
        >
          <AreaManager
            v-for="task in areaManager.tasks_created"
            :key="task.id"
            :area-manager="areaManager"
            :task="task"
          />
        </BCardText>
      </BCard>
    </BCardGroup>
  </BContainer>
</template>
<script>
import AreaManager from '@/views/audit/dashboard/components/AreaManager.vue'

export default {
  name: 'VAuditDashboard',

  components: {
    AreaManager
  },

  props: {
    busy: {
      type: Boolean,
      default: () => false
    },
    areaManagers: {
      type: Object,
      default: () => ({
        totalRows: 0,
        rows: []
      })
    }
  },

  methods: {
    computedProfilePath (photoUrl) {
      return `${process.env.VUE_APP_API_BASE_URL}/${photoUrl}`
    }
  }
}
</script>
